import { useMemo } from 'react';
import { useRecoilValueLoadable } from 'recoil';
import { MaterialAutocomplete } from '../../../common/formik-material-ui';
import { IUserModel } from '../../../recoil/atoms/user';
import { methodNameEnum } from '../../../recoil/selectors/makePHPRequest';
import {
  endpointEnum,
  makeAPIRequest,
} from '../../../services/rest/makeAPIRequest';

export function AgentDropdown(props: {
  handleChange: (...args: any) => void;
  userId: number | string;
}) {
  const dataUsers = {
    call: methodNameEnum.GET_BUSINESS_USERS,
  };
  const businessUsers = useRecoilValueLoadable(
    makeAPIRequest({
      endpoint: endpointEnum.GET_BUSINESS_USERS,
      payloadJsonString: JSON.stringify(dataUsers),
    })
  );
  const activeUsers = useMemo(
    () =>
      businessUsers.state === 'hasValue'
        ? businessUsers.contents?.response?.data?.result
            ?.filter((user) => user.isactive === 1)
            ?.sort((a, b) =>
              a.fname.toLowerCase().localeCompare(b.fname.toLowerCase())
            )
        : [],
    [businessUsers]
  );
  const defaultUser = useMemo(
    () =>
      businessUsers.state === 'hasValue'
        ? activeUsers?.find((user: IUserModel) => user.userid == props.userId)
        : {},
    [businessUsers, props.userId]
  );
  return (
    <MaterialAutocomplete
      type="text"
      style={{ width: '280px' }}
      label="Agent"
      size="small"
      variant="outlined"
      multiple={false}
      options={activeUsers ?? []}
      value={defaultUser ?? {}}
      onChange={(event, newValue) => {
        props.handleChange(newValue);
      }}
      getOptionLabel={(option) =>
        option ? `${option?.fname} ${option?.lname}` : ''
      }
      isOptionEqualToValue={(option, value) => option?.userid === value?.userid}
    />
  );
}
